__turbopack_context__.v({
  "progressionBar": "styles-module__rc1VhG__progressionBar",
  "progressionBarCompleted": "styles-module__rc1VhG__progressionBarCompleted",
  "progressionBarContainer": "styles-module__rc1VhG__progressionBarContainer",
  "visuallyHidden": "styles-module__rc1VhG__visuallyHidden",
});
